import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import './financial.scss';
import AOS from "aos";
import "aos/dist/aos.css";

export default function FinancialSummary() {

  useEffect(() => {
    AOS.init({
      once: true
    });
    AOS.refresh();
  }, []);
    
  return (
    <>
      <h5>Financial Industry Summary</h5>
      <ul className="financial-listing">
        <li>Financial companies report having the <span data-aos className='highlighter highlighter-summary'>highest expertise with direct mail.</span></li>
        <li>Financial businesses say direct mail is <span data-aos className='highlighter highlighter-summary'>as effective or more effective than other channels,</span> except for social media (by 1%).</li>
        <li>They are the <span data-aos className='highlighter highlighter-summary'>most likely to track the effectiveness</span> of direct mail.</li>
        <li>Out of all direct mail techniques, financial companies most <span data-aos className='highlighter highlighter-summary'>often use personalized offers.</span></li>
      </ul>
    </>
  );
}
